import React, { useCallback } from 'react';
import * as Styles from './StudioTopBanner.styles';
import { GradientButton } from '@/pages/Studio/components';
import snappy from './media/snappy.svg';
import withErrorBoundary from '@/utils/errorBoundary';
import { isBRServer } from '@/utils/Validators/validation';

const StudioTopBanner = ({
  bannerAdLocale, trialAvailable, provisionFreePlan, handleShowModal, clickAdvertising,
}) => {
  const handleClick = useCallback(() => {
    clickAdvertising();

    if (trialAvailable) {
      handleShowModal(); return;
    }

    provisionFreePlan();
  }, [trialAvailable, provisionFreePlan, clickAdvertising, handleShowModal]);

  return (
    <Styles.BannerWrapper data-testid="studio-top-banner">
      <Styles.BannerContainer>
        <Styles.BannerContainerInner>
          <Styles.CollumnLeft>
            <Styles.Snappy src={snappy} alt="Snappy" />
          </Styles.CollumnLeft>

          <Styles.CollumnCenter>
            <Styles.Badge>{bannerAdLocale.badge}</Styles.Badge>
            <Styles.Title locale={isBRServer ? 'br' : 'es'}>{bannerAdLocale.title.top}</Styles.Title>
          </Styles.CollumnCenter>

          <Styles.CollumnRight>
            <GradientButton
              testId="upgrade-to-pro-button"
              label={bannerAdLocale.buttonLabel.top}
              onClick={() => handleClick()}
              size="md"
              variant="tertiary"
            />
          </Styles.CollumnRight>
        </Styles.BannerContainerInner>
      </Styles.BannerContainer>
    </Styles.BannerWrapper>
  );
};

export default withErrorBoundary(StudioTopBanner, 'StudioTopBanner');
